/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';

interface IChevronRightProps extends React.HTMLProps<SVGSVGElement> {
  color?: string;
}

export function Chevron({ className, color, ...rest }: IChevronRightProps) {
  return (
    // eslint-disable-next-line react/forbid-elements
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 10 6"
      className={className}
      {...(rest as any)}
    >
      <path
        fill={color || '#2b87db'}
        fillRule="evenodd"
        // tslint:disable-next-line:max-line-length
        d="M8.372.28L5 3.65 1.628.28A.954.954 0 0 0 .28 1.627l4.046 4.046a.953.953 0 0 0 1.35 0L9.72 1.628A.955.955 0 0 0 8.37.278z"
      />
    </svg>
  );
}
